export enum TagsUsage {
    Partner = 1
}